/**
 *  @class
 *  @function FacetsToggle
 */
if (!customElements.get('facets-toggle')) {
  class FacetsToggle extends HTMLElement {
    connectedCallback() {
      this.drawer = document.getElementById('Facet-Drawer');

      this.addEventListener('click', (e) => {
        e.preventDefault();
        if (OverlayManager.isOpen(this.drawer)) {
          OverlayManager.close(this.drawer);
        } else {
          OverlayManager.open(this.drawer);
        }
      });

      setTimeout(() => {
        window.dispatchEvent(new Event('resize.resize-select'));
      }, 10);
    }
  }
  customElements.define('facets-toggle', FacetsToggle);
}


class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const container = document.getElementsByClassName('thb-filter-count');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');

    for (var item of container) {
      item.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      if (FacetFiltersForm.filterData.some(filterDataUrl)) {
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event);
      } else {
        FacetFiltersForm.renderSectionFromFetch(url, event);
      }
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    FacetFiltersForm.publishFacetUpdate(searchParams);
  }

  // shopify:collection:update / shopify:search:update — filters or sort changed
  static publishFacetUpdate(searchParams) {
    const SE = window.Shopify && window.Shopify.StandardEvents;
    if (!SE) return;
    const params = new URLSearchParams(searchParams);

    if (theme.settings.collection_id) {
      publishStandardEvent('CollectionUpdateEvent', {
        collection: { id: theme.settings.collection_id },
        filters: SE.CollectionUpdateEvent.parseProductFilters(params),
        sortKey: SE.CollectionUpdateEvent.getSortKey(params)
      });
    } else if (window.location.pathname.indexOf(theme.routes.search_url) !== -1) {
      publishStandardEvent('SearchUpdateEvent', {
        searchTerm: params.get('q') || new URLSearchParams(window.location.search).get('q') || '',
        filters: SE.SearchUpdateEvent.parseProductFilters(params),
        sortKey: SE.SearchUpdateEvent.getSortKey(params)
      });
    }
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, {
          html,
          url
        }];
        withViewTransition(() => {
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
        });
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    withViewTransition(() => {
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
    });
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

    let top = document.getElementById('ProductGridContainer').getBoundingClientRect().top + document.documentElement.scrollTop - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) - 30;

    window.scrollTo({
      top: top,
      left: 0,
      behavior: "smooth"
    });
  }

  static renderProductCount(html) {
    const countHtml = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
    const container = document.getElementsByClassName('thb-filter-count');

    if (countHtml) {
      for (var item of container) {
        item.innerHTML = countHtml.innerHTML;
        item.classList.remove('loading');
      }
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    // #FacetFiltersFormMobile is the only facets form that lives outside
    // #ProductGridContainer, so it's the only one this function needs to touch.
    // #FacetFiltersForm (desktop sidebar) and #FacetFiltersForm-bar (horizontal bar)
    // both live inside #ProductGridContainer and get a full, clean replace from
    // renderProductGridContainer() right after this function returns.
    const mobileForm = document.getElementById('FacetFiltersFormMobile');
    if (!mobileForm) return;

    // Always do a full rebuild of every mobile collapsible-row from the response.
    //
    // The previous index-based patching approach was fragile: on collections where
    // the available filter set changes when a filter is applied (e.g. "Bestsellers"
    // and "Tipo de suela" disappear when filtering to a single brand), the
    // collapsible-row indices in the stale DOM no longer correspond to the same
    // filters in the AJAX response. For example, in promo-week without any filter
    // Marca sits at index 4; after selecting Adidas the response puts Marca at
    // index 3. The old code tried to skip the clicked row by its stale index (4),
    // but index 4 in the response is "Tipo de ropa", not Marca — so the response's
    // Marca content (index 3) was injected into the "Bestsellers" slot of the stale
    // form while the original Marca row was left untouched, producing two complete
    // Marca filter sections in the drawer.
    //
    // A full rebuild avoids index matching entirely: the server response always
    // contains the definitive, correct filter state (including checked attributes),
    // so cloning its rows wholesale is both simpler and correct in every case.
    const responseRows = parsedHTML.querySelectorAll('#FacetFiltersFormMobile collapsible-row');
    const sortSection = mobileForm.querySelector('.thb-filter-sort-count');
    mobileForm.querySelectorAll('collapsible-row').forEach(row => row.remove());
    responseRows.forEach(row => {
      const clone = row.cloneNode(true);
      if (sortSection) {
        mobileForm.insertBefore(clone, sortSection);
      } else {
        mobileForm.appendChild(clone);
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-filter-count'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({
      searchParams
    }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }];
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData);
    if (searchParams.get('filter.v.price.gte') === "0.00") {
      searchParams.delete('filter.v.price.gte');
    }
    if (document.querySelector('.price_slider')) {
      if (searchParams.get('filter.v.price.lte') === parseFloat(document.querySelector('.price_slider').dataset.max).toFixed(2)) {
        searchParams.delete('filter.v.price.lte');
      }
    }
    FacetFiltersForm.renderPage(searchParams.toString(), event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();


class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('a').forEach((item) => {
      item.addEventListener('click', (event) => {
        event.preventDefault();
        const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
        form.onActiveFilterClick(event);
      });
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/**
 *  @class
 *  @function PriceSlider
 */
class PriceSlider extends HTMLElement {

  constructor() {
    super();
  }
  connectedCallback() {
    let slider = this.querySelector('.price_slider'),
      amounts = this.querySelector('.price_slider_amount'),
      args = {
        start: [parseFloat(slider.dataset.minValue || 0), parseFloat(slider.dataset.maxValue || slider.dataset.max)],
        connect: true,
        step: 10,
        direction: document.dir,
        handleAttributes: [
          { 'aria-label': 'lower' },
          { 'aria-label': 'upper' },
        ],
        range: {
          'min': 0,
          'max': parseFloat(slider.dataset.max)
        }
      },
      event = new CustomEvent('input'),
      form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');

    if (slider.classList.contains('noUi-target')) {
      slider.noUiSlider.destroy();
    }
    noUiSlider.create(slider, args);

    slider.noUiSlider.on('update', function (values) {
      amounts.querySelector('.field__input_min').value = values[0];
      amounts.querySelector('.field__input_max').value = values[1];
    });
    slider.noUiSlider.on('change', function (values) {
      form.querySelector('form').dispatchEvent(event);
    });
  }
}
customElements.define('price-slider', PriceSlider);

(function () {
  const updateShift = (label) => {
    const content = label.querySelector('.facet-tooltip__content');
    if (!content) return;
    label.style.setProperty('--tooltip-shift', '0px');
    const rect = content.getBoundingClientRect();
    const gutter = 8;
    const vw = document.documentElement.clientWidth;
    let shift = 0;
    if (rect.left < gutter) {
      shift = Math.round(gutter - rect.left);
    } else if (rect.right > vw - gutter) {
      shift = Math.round(vw - gutter - rect.right);
    }
    label.style.setProperty('--tooltip-shift', shift + 'px');
  };

  document.addEventListener('mouseover', (e) => {
    if (!e.target.closest) return;
    const label = e.target.closest('.facet-checkbox--tooltip');
    if (!label || label._tooltipHovered) return;
    label._tooltipHovered = true;
    updateShift(label);
  });

  document.addEventListener('mouseout', (e) => {
    if (!e.target.closest) return;
    const label = e.target.closest('.facet-checkbox--tooltip');
    if (!label) return;
    if (!label.contains(e.relatedTarget)) {
      label._tooltipHovered = false;
    }
  });
})();
